<template>
  <div :class="classes()">
    <div :class="`${el}__top`">
      <Row>
        <Col :xs="12" :l="3" :class="`${el}__col`">
          <div :class="`${el}__outer ${el}__head`">
            <Icon :class="`${el}__headImage`" :name="head.image" />
            <Copy size="l" color="neutral80" bold element="div"><div v-html="head.copy" /></Copy>
          </div>
          <svg
            v-if="$matchMedia.l"
            :width="40"
            viewBox="0 0 40 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="`background-color: ${colors.secondaryMintLighter}`"
          >
            <path
              d="M39.5 80L-3.09447e-05 160L-3.8147e-05 -6.58175e-05L39.5 80Z"
              :fill="`${colors.secondaryMint}`"
            />
          </svg>
        </Col>
        <Col :xs="12" :l="6">
          <div :class="`${el}__body`">
            <div :class="`${el}__bodyInner`">
              <Copy :staticClass="`${el}__bodyCopy`" element="div">{{ body.copy }}</Copy>
              <ul :class="`${el}__bodyList`">
                <li
                  v-for="(text, i) in body.list"
                  :key="`bodyListItem-${i}`"
                  :class="`${el}__bodyListItem`"
                >
                  {{ text.trim() }}
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col :xs="12" :l="3" :class="`${el}__col`">
          <svg
            v-if="$matchMedia.l"
            :width="40"
            viewBox="0 0 40 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="`background-color: ${colors.secondaryMint}`"
          >
            <path
              d="M39.5 80L-3.09447e-05 160L-3.8147e-05 -6.58175e-05L39.5 80Z"
              :fill="`${colors.secondaryMintLighter}`"
            />
          </svg>
          <div :class="`${el}__outer`">
            <Copy :staticClass="`${el}__switcherCopy`" element="div" bold>
              {{ switcher.copy }}
            </Copy>
            <div :class="`${el}__switcher`">
              <slot name="ToggleSwitch" />
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <div :class="`${el}__radioGroups`">
      <Headline
        :staticClass="`${el}__radioGroupHeadline${
          radioGroup[0].visible ? ` ${el}__radioGroupHeadline--visible` : ''
        }`"
        size="s"
        :heading="4"
      >
        {{ radioGroupHeadline }}
      </Headline>
      <div
        v-for="(radioGroupItem, i) in radioGroup"
        :key="`radioGroupItem-${i}`"
        :class="{
          [`${el}__radioGroup`]: true,
          [`${el}__radioGroup--visible`]: radioGroupItem.visible,
        }"
      >
        <div :class="`${el}__radioGroupIndicator`">
          <Copy
            :staticClass="`${el}__radioGroupIndicatorInner`"
            size="l"
            element="div"
            color="primaryBlue"
            bold
          >
            {{ `${i + 1}/${radioGroup.length}` }}
          </Copy>
        </div>
        <div :class="`${el}__radioGroupForms`">
          <Copy element="div" :staticClass="`${el}__radioGroupFormsHeadline`" bold>
            {{ radioGroupItem.headline }}
          </Copy>
          <slot :name="radioGroupItem.slotName" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import colors from '@/styles/base/_colors.scss';

export default {
  name: 'SwitcherRow',
  props: {
    // content: Object,
    head: {
      image: String,
      copy: String,
    },
    body: {
      copy: String,
      list: Array,
    },
    switcher: {
      copy: String,
    },
    radioGroupHeadline: String,
    radioGroup: {
      headline: String,
      slotName: Object,
      visible: Boolean,
    },
  },
  components: {
    Headline,
    Icon,
    Copy,
    Row,
    Col,
  },
  data() {
    return {
      // ...this.content,
      colors,
      el: 'c-switcherRow',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
